<button
  class="button"
  #contentWrapper
  [ngClass]="buttonClasses"
  [disabled]="_disabled"
  [ngStyle]="styles"
  (click)="onClick.emit($event)"
  (focus)="onFocus.emit($event)"
  (blur)="onBlur.emit($event)"
>
  <ng-content></ng-content>
</button>

